import * as React from 'react';

import * as Styled from './toggle.styles';
import type { ToggleProps } from './toggle.types';

export const Toggle = React.forwardRef<HTMLInputElement, ToggleProps>(
  (
    { className, disabled, error, name, on, onChange, ...props },
    forwardedRef
  ) => {
    const iconProps = {
      $checked: on,
      $disabled: disabled,
      $error: error,
      'aria-hidden': true,
      height: 12,
      width: 12,
    };

    return (
      <Styled.ToggleContainer className={className}>
        <Styled.Toggle
          $checked={on}
          $disabled={disabled}
          $error={error}
          aria-checked={on}
          aria-invalid={error ? true : undefined}
          data-xds="Toggle"
          disabled={disabled}
          name={name}
          onChange={onChange}
          ref={forwardedRef}
          role="switch"
          type="checkbox"
          {...{ [onChange ? 'checked' : 'defaultChecked']: on }}
          {...props}
        />
        <Styled.Handle $checked={on} $disabled={disabled} $error={error}>
          <Styled.CrossIcon {...iconProps} />
          <Styled.CheckIcon {...iconProps} />
        </Styled.Handle>
      </Styled.ToggleContainer>
    );
  }
);

Toggle.displayName = 'Toggle';
